/* eslint-disable import/prefer-default-export */
export const AUTO_EQUIPPED_CATEGORIES = [
  'Club',
  'Destiny',
  'Ship',
  'Spouse',
];